import { AuthenticatedGuard } from "@/components/authenticated-guard";
import Header from "@/components/header.tsx";
import { OperatorImpersonationGate } from "@/components/registrant/operator-impersonation-gate";
import { UserType } from "@/constants";
import { getRegistrantSignupConnection } from "@/lib/auth0-registrant-signup-connection";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import Auth0Provider from "../integrations/auth0/root-provider.tsx";

function AccountSetupLayout() {
  const { user } = useAuth0();

  return (
    <>
      <Header
        user={user || null}
        userNavVariant="logout-only"
        showRegistrantOperatorImpersonation
        showRegistrantHelp
      />
      <main className="flex flex-1 w-full justify-center p-4 md:p-6 max-w-[1600px] mx-auto bg-background">
        <AuthenticatedGuard
          allowedUserTypes={[UserType.REGISTRANT, UserType.OPERATOR]}
          loginConnection={getRegistrantSignupConnection()}
        >
          <OperatorImpersonationGate>
            <Outlet />
          </OperatorImpersonationGate>
        </AuthenticatedGuard>
      </main>
    </>
  );
}

export const Route = createFileRoute("/account-setup")({
  component: () => (
    <Auth0Provider
      audience={import.meta.env.VITE_AUTH0_REGISTRANT_AUDIENCE}
      clientId={import.meta.env.VITE_AUTH0_REGISTRANT_CLIENT_ID}
      callbackPath="/registrant/auth_callback"
    >
      <AccountSetupLayout />
    </Auth0Provider>
  ),
});
